import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { navEntries } from "@/mocks/home";

export default function NavSection() {
  return (
    <section id="nav" className="w-full bg-background-50">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="BLACK-TALK NAVIGATION"
            title="黑料导航 · 一页找到所有入口"
            desc="专题、专区、频道、栏目、排行与标签，常用入口全部收在这一屏，少翻两层也少迷路。"
          />
        </Reveal>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {navEntries.map((entry, index) => (
            <Reveal key={entry.label} delay={index * 40}>
              <a
                href="#nav"
                className="group flex h-full items-start gap-3.5 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors duration-300 hover:border-primary-300 cursor-pointer"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-100 text-foreground-700 transition-colors duration-300 group-hover:bg-primary-100 group-hover:text-primary-700">
                  <i className={`${entry.icon} text-lg`} />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center gap-2">
                    <span className="font-heading text-base font-bold text-foreground-950">
                      {entry.label}
                    </span>
                    {entry.tag ? (
                      <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-label text-secondary-900">
                        {entry.tag}
                      </span>
                    ) : null}
                  </span>
                  <span className="mt-1.5 block text-xs leading-relaxed text-foreground-600">
                    {entry.desc}
                  </span>
                </span>
                <i className="ri-arrow-right-up-line text-base text-foreground-300 transition-colors duration-300 group-hover:text-primary-600" />
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}